import { Injectable, Sanitizer, inject } from "@angular/core";
import RecordRTC from "recordrtc";
import { Subject } from "rxjs";
import { HTTPService } from "../services/http.service";
import { UploadServices } from "../services/upload.services";
import { GenericEdit } from "../interfaces/generic-edit";
import { ObjectUtil } from "../system-utils/utils/ObjectUtil";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable()
export class VideoRecordingService {
  progress: number;
  
  
  saveVideo(codeContract, codeCompany, codeMktp, name) {
    
    return new Promise((resolve,reject)=>{
      let ob = {
        entityName:'Mktpmedia',
        CODECOMPANY:codeCompany,
        CODECONTRACT:codeContract,
        CODEMKTP: codeMktp,
        NAME: name
      }
      this.http.post(ob,'JsonBrokerServices/save',false,true,false).subscribe({
          next:async (retorno)=>{
              let internalId = retorno['INTERNALID'];
              await this.callUploadService(this.blob,'Mktpmedia','BLOB',`INTERNALID=${internalId}`).then(d=>{
                resolve(true);
              });
              
          },
          error:(error)=>{
              throw error;
          }
      });
    });
    
    
  }

  private mediaStream: any;
  private recorder: any;
  private blob: any;
  private _mediaStream = new Subject<any>();
  private _blob = new Subject<any>();
  private http:HTTPService = inject(HTTPService);
  private sanitizer:DomSanitizer =  inject(DomSanitizer);
  private updLoad:UploadServices = inject(UploadServices);
  
  // getObservable
  getMediaStream() {
    return this._mediaStream.asObservable();
  }

  getBlob() {
    return this._blob.asObservable();
  }

  startRecording() {
    this.handleRecording();
  }

  async handleRecording() {
    // @ts-ignore
    this.mediaStream = await navigator.mediaDevices.getDisplayMedia({
      audio: true,
      video:{
        displaySurface: "window",
        
      },
    });
    this._mediaStream.next(this.mediaStream);
    this.recorder = new RecordRTC(this.mediaStream, { type: 'video' });
    this.recorder.startRecording();
  }

  stopRecording() {
    if (!this.recorder) {
      return;
    }
    this.recorder.stopRecording(() => {
      this.blob = this.recorder.getBlob();
      this._blob.next(URL.createObjectURL(this.blob));
      this.mediaStream.stop();
      this.recorder.destroy();
      this.mediaStream = null;
      this.recorder = null;
    })
  }

  downloadRecording() {
    RecordRTC.invokeSaveAsDialog(this.blob, `${Date.now()}.webm`);
  }

  clearRecording() {
    this.blob = null;
    this.recorder = null;
    this.mediaStream = null;
  }


  callUploadService(file:Blob, entityName:string, columnName:string, condicao:string) {  
  
    return new Promise((resolve,reject)=>{
      const formData = new FormData();  
      formData.append('file', this.blob, 'image');  
      let ob = {
          entityName: entityName,
          datafield: columnName,
          condition: condicao
      }
      
      formData.append('data',JSON.stringify(ob));
    
      
      this.updLoad.progress.subscribe(number=>{
        this.progress = number;
        if ( number == 100 ){
            resolve(true);
        }
      });
 
      
      this.updLoad.upLoadFile(formData, true).subscribe({
        complete:()=>this.progress = 0
      });    
    
    });
  }

  loadData(data:GenericEdit){

    return new Promise((resolve,reject)=>{
      let ob = {
        entityName: 'Mktpmedia',
        condition: `INTERNALID=${data.row['INTERNALID']}`,
        rows: 1,
        showImageData: true,
        showImageDataBase64: true
      }

      this.http.post(ob,'JsonBrokerServices/find',false,true,true).subscribe(data=>{
          if (  ObjectUtil.isNotEmpty(data['Mktpmedia']) && 
                ObjectUtil.isNotEmpty(data['Mktpmedia'][0]) && 
                ObjectUtil.isNotEmpty(data['Mktpmedia'][0]['BLOB'] )){

              let image:string = data['Mktpmedia'][0]['BLOB'];
              let path ="data:video/webm;charset=utf-8;base64,"+image;
              let decodedData = atob(image);
              const uInt8Array = new Uint8Array(decodedData.length);

              // Insert all character code into uInt8Array
              for (let i = 0; i < decodedData.length; ++i) {
                uInt8Array[i] = decodedData.charCodeAt(i);
              }

              let blob:Blob = new Blob([uInt8Array], {type:'video/webm'});
              this.blob = blob;
              resolve(path)
          }else{
              reject();
          } 
      },error=>{
          throw error;
      },()=>{

      });
    })
    
  }
}